import * as React from 'react';
import Fuse from 'fuse.js';
import styled from 'styled-components';
import { Box } from '@openfin/ui-library';
import { NotificationCard } from '../NotificationCard/NotificationCard';
import type { StoredNotification } from '../../../model/StoredNotification';
import { isStoredNotification } from '../../../utils';
import { AnimatePresence, AnimateSharedLayout, motion, Variants } from 'framer-motion';

interface Props {
  notifications: (StoredNotification | Fuse.FuseResult<StoredNotification>)[];
}

export const NotificationList: React.FC<Props> = ({ notifications }) => {
  const variants: Variants = {
    visible: { opacity: 1, zIndex: 2, y: 0, scale: 1 },
    hidden: { opacity: 0, zIndex: 0, y: -200, scale: 0.5 },
  };

  return (
    <Container flexDirection="column">
      <AnimateSharedLayout>
        <Content flexDirection="column" as={motion.div} layout>
          <AnimatePresence initial={false}>
            {notifications.map((x) => {
              const nft = isStoredNotification(x) ? x : x.item;
              return (
                <motion.div
                  layout
                  key={nft.id}
                  variants={variants}
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  transition={{
                    type: 'spring',
                    duration: 0.3,
                    bounce: 0.25,
                  }}
                >
                  <NotificationCard key={nft.id} notification={nft} />
                </motion.div>
              );
            })}
          </AnimatePresence>
        </Content>
      </AnimateSharedLayout>
    </Container>
  );
};

const Container = styled(Box)`
  position: relative;
  flex: 1 1 auto;
  overflow-y: overlay;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  padding-top: ${({ theme }) => theme.px.small};
`;

const Content = styled(Box)`
  gap: ${({ theme }) => theme.px.base} 0;
  padding-bottom: ${({ theme }) => theme.px.base};
  margin: 0 auto;
`;
